export default "__VITE_ASSET__5dc426a6__"